import { Modal } from "../../../components"
import PassosResetSenha from "./passosResetSenha"



function ModalResetSenha({open, setCloseModal, cpf}){
  return(
    <Modal open={open} style={{ borderRadius: 8}}>
      <PassosResetSenha setCloseModal={setCloseModal} cpf={cpf}/>
    </Modal>
  )
}

export default ModalResetSenha